import { writable, get } from 'svelte/store'
import { createClass } from "asteroid";
const Asteroid = createClass();


const endpoint = window.location.hostname == 'localhost' ? 'ws://localhost:3000/websocket' : "wss://typostock.grottolabs.com/websocket"
// const endpoint = "wss://typostock.grottolabs.com/websocket"

// // Connect to a Meteor backend
export const asteroid = new Asteroid({ endpoint });

export let subscriptionReady = writable(false)
export let user = writable(false)

window._asteroid = asteroid

asteroid.ddp.on('added', ({ collection, id, fields }) => {
    collections[collection]
        .update(_collection => {
            _collection[id] = Object.assign({ _id: id }, fields)
            observable(collection, id).set(_collection[id])
            return _collection
        })
})

asteroid.ddp.on('changed', ({ collection, id, fields }) => {
    collections[collection]
        .update(_collection => {
            _collection[id] = Object.assign(_collection[id], fields)
            observable(collection, id).set(_collection[id])
            return _collection
        })
})

asteroid.ddp.on('removed', ({ collection, id }) => {
    collections[collection]
        .update(_collection => {
            delete _collection[id]
            return _collection
        })
})

asteroid.ddp.on("connected", (a, b) => {
    asteroid.subscribe('userdata') //this line adds role field to user
    setTimeout(() => {
        subscriptionReady.set(true)
    }, 500)
})


asteroid.ddp.on('result', ({ msg, result }) => {
    const { token, id } = result || {}

    if (token && id) {
        const _user = get(collections.users)[id]
        user.set(_user)
        subscriptionReady.set(true)
        console.log('logged in', get(user))
    }
})

export const collections = {
    users: writable({}),
    products: writable({}),
    logs: writable({}),
    orders: writable({}),
    customers: writable({}),
    metas: writable({})
}


export function Subscriber(collectionName, query, options) {
    const store = writable({ collectionName, query, options, id: null, active: false })


    function setQuery(collectionName, query, options) {
        const _store = get(store)
        store.set({
            oldId: _store.oldId,
            collectionName: collectionName || _store.collectionName,
            query: query || _store.query,
            options: options || _store.options,
            active: _store.active
        })
        if (_store.active) subscribe()
    }

    function subscribe() {
        const { oldId, collectionName, query, options } = get(store)
        store.update(store => (store.active = true) && store)
        if (collectionName) {
            const { id } = asteroid.subscribe(collectionName, query || {}, options || {});
            if (oldId && oldId != id) unsubscribe(oldId)
            store.update(store => (store.oldId = id) && store)
        }
        return unsubscribe
    }

    function unsubscribe() {
        const oldId = get(store).oldId
        if (oldId) asteroid.unsubscribe(oldId)
    }


    return {
        setQuery,
        unsubscribe,
        subscribe
    }
}




const _observers = {}

export function observable(collection, id) {
    const key = collection + '-' + id
    if (!_observers[key]) {
        _observers[key] = observableStore(collection, id)
    }
    return _observers[key]
}

function observableStore(collection, id) {
    const document = get(collections[collection])[id] || {}
    const { subscribe, set } = writable(document)

    function _subscribe (...params){
        console.log('subscribing', collection, id)
        const subId = asteroid.subscribe(collection, id).id
        const unsubscribe = subscribe(...params)
        return function(...params){
            console.log('unsubscribe', collection, id, subId)
            asteroid.unsubscribe(subId)
            return unsubscribe(...params)
        }
    }

    return { subscribe: _subscribe, set }
}